export default __webpack_public_path__ + "static/media/Group291.4a1197d0.png";